<template>
  <align
    direction="flex-start"
    small-gap
    :class="['card-watchlist-details', { config: hasConfig, alert: hasAlert }]"
    @click.native="setupAlerts"
  >
    <icon-button
      :icon="alertIcon"
      tooltip="Setup price alerts"
      @click="setupAlerts"
    />

    <div class="text">
      {{ alertText }}
    </div>
  </align>
</template>

<script>
import {
  hasConfig,
  hasAlert,
  getAlertText,
  getAlertIcon,
} from '@cardladder/shared/utils/watchlist.util';

export default {
  props: {
    card: Object,
  },

  computed: {
    hasConfig() {
      return hasConfig(this.card);
    },

    hasAlert() {
      return hasAlert(this.card);
    },

    alertText() {
      return getAlertText(this.card);
    },

    alertIcon() {
      return getAlertIcon(this.card);
    },
  },

  methods: {
    setupAlerts() {
      this.$bus.$emit('watchlist-alert-setup', this.card);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-watchlist-details {
  --alert-bg: var(--theme-border);

  cursor: pointer;
  margin-bottom: $gp;
  padding: $gp;
  border-radius: $border-radius;
  position: relative;
  border: 1px solid var(--alert-bg);
  overflow: hidden;

  &:before {
    content: '';
    background-color: var(--alert-bg);
    position: absolute;
    opacity: 0.25;
    inset: 0;
  }

  .text,
  .icon-button {
    position: relative;
  }

  .text {
    font-weight: bold;
    line-height: 22px;
  }

  &.config {
    --alert-bg: #{$color-green-1};
  }

  &.alert {
    --alert-bg: #{$color-red-1};
  }

  &:active {
    opacity: 0.5;
  }
}
</style>
